import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiConnector, Table } from '@cureskin/api-client';
import { IframeService } from 'src/services/iframe-service';
import { ConnectionService } from '../../../../services/connection-service';
import { AppConfig } from '../../../app.config';
import { HelperService } from '../../../../services/helper-service';
import { ConsultationSessionInfoPopup } from './consultation-info-popup';

@Component({
    selector: 'consultation-list', templateUrl: './consultation-list.html', styleUrls: ['./consultation-list.scss'],
    standalone: false
})
export class ConsultatioListComponent {
  @Output() updatedConsultationId: EventEmitter<any> = new EventEmitter();
  @Input('user')
  set userFunction(user: any) {
    this.user = user;
    this.fetchUserConsultations();
  }
  user: any;
  webAppUrl: any;
  consultationSessions: Array<any> = [];
  @Input() newUI: boolean = false;

  constructor(public appConfig: AppConfig,
    private conn: ConnectionService,
    public helper: HelperService,
    private dialog: MatDialog,
    private iframeService: IframeService) {
  }

  async ngOnInit(): Promise<any> {
  }

  openConsultationPopup(consultationSession: any): void {
    this.dialog.open(ConsultationSessionInfoPopup, { width: '75%', data: { consultationSession } });
  }

  async fetchUserConsultations(): Promise<any> {
    this.consultationSessions = await ApiConnector.find(Table.ConsultationSession, {
      where: { user: this.user },
      include: ['PrivateRegimenGivenPointer'],
      project: [
        'PrivateMainConcernClass',
        'archive',
        'PrivateMainConcern',
        'PrivateInstantCheckupDebug',
        'PrivateRegimenGiven',
        'username',
        'treePaths'
      ],
      descending: 'createdAt',
    });
  }

  loadConsultation(id: string): void {
    if (this.newUI) {
      this.iframeService.updateIframeUrl(`${this.conn.getWebAppUrl()}/chatV2/${id}?userId=${this.user.id}&type=consultationSession`);
    } else {
      this.updatedConsultationId.emit(id);
    }
  }
}
